import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ProtectedTabs = ({ children }) => {
 
  const {
    list: userDetails,
    loading: userDetailsLoader,
    countryList,

  } = useSelector((state) => state.user);
 

  if (userDetails?.role === "admin") {
    return <>{children}</>;
  }

  if (userDetails?.role === "carSeller") {
    return (
      <>
        {(children?.props?.to == "/usedCars" ||
          children?.props?.to == "/home") &&
          children}
      </>
    );
  }

  return null;
};

export default ProtectedTabs;
